module.exports = {
  "resume-editor": {
    resumeTemplates: {
      default: ["prestige", "greyline"],
      gala: ["lightcharactercard", "darkcharactercard"],
    },
  },
  coach: {
    coachingSurvey: 0,
    motivationSurvey: 1,
    feedbackFrequency: 2,
  },
  hibob: {
    apiKey: "xxx-xxxx-xxxx-xxx",
  },
  journey: {
    steps: [],
  },
  alex: {
    gala: {
      chatBotFormId: "pnw2LVto",
    },
    default: {
      chatBotFormId: "pnw2LVto",
    },
    getboarded: {
      chatBotFormId: "pnw2LVto",
    },
    datarmony: {
      chatBotFormId: "a8g2DkK6",
    },
  },
};
